import React, { Component } from "react";
import FetchCall, { partnerApi, updateVideo } from './../../../../API/FetchCall';

import SimpleReactValidator from 'simple-react-validator';

import jQuery from 'jquery';
import {
  Collapse,
  CardBody,
  Card,
  CardHeader
} from 'reactstrap';

import 'react-notifications/lib/notifications.css';

import {NotificationContainer, NotificationManager} from 'react-notifications';

class Videos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_data: JSON.parse(localStorage.getItem("user_data")),
      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
      user_type: 0,
      exist_video: '',
      access: [],
      photos_arr: [],
      delete_array: [],
      edit_image: '',
      url: '',
      image_count: 0,
      photos_arr_length: 0,
      showupload: false, imagename: '', newimage: '', removeindex: '',
      attachment_file: [],
      attachment_file_length: 0,
      attachment_fileName: [],
      tempBanner: '',
      active_status: 0,
      main_id: 0,
      main_access: '',
      btnDisabled: false,
      collapse: 0,
      page_data: []
    }
    this.validator = new SimpleReactValidator({
      validators: {
        checkExist: {  // name the rule
          message: 'The :attribute field is required.',
          rule: (val, params, validator) => {
            if (val == '' && this.state.edit_image == '') {
              return false;
            }
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        }
      }
    });

    // this.getgallery();
    this.getVideo();
    this.toggle = this.toggle.bind(this);
  }
  toggle(event) {
    this.setState({
      collapse: this.state.collapse === Number(event) ? -1 : Number(event)
    });
  }
  componentDidMount() {
    if (this.state.authentication == true) {
      this.setState({
        access: this.state.user_data.current_category.split(','),
        user_type: this.state.user_data.user_type
        // access: [1]
      });
    }
  }
  getVideo = () => {
    const { user_type, login_id, set_id } = this.state.user_data;
    let req = JSON.stringify({
      user_type: user_type,
      login_id: login_id,
      sid: set_id,
      url: 'getVideoNew'
    });
    partnerApi(req).then((response) => {
      if (response.status === 1) {
        let data = response.result;
        this.setState({
          active_status: data.active_status,
          page_data: data.master_data
        });
      }
      console.log(this.state.photos_arr);
    })
  }
  // getgallery = () => {
  //   const { user_type, login_id, is_completd, current_category } = this.state.user_data;
  //   let req = JSON.stringify({
  //     user_type: user_type,
  //     login_id: login_id,
  //     is_completd: is_completd,
  //     category: current_category,
  //     url: 'getContactData'
  //   });
  //   partnerApi(req).then((response) => {
  //     console.log('response on videos', response);
  //     if (response.status === 1) {
  //       let data = response.result;
  //       if (data.video_path)
  //         this.setState({
  //           video_new: '',
  //           active_status: data.active_status,
  //           exist_video: data.url + data.video_path,
  //           main_access: data.main_access ? data.main_access : 0,
  //         });
  //     }
  //     console.log(this.state.photos_arr);
  //   })onSubmit={(e) => this.submitForm(e, index)
  // }
  handleFile = (e, index) => {
    const propName = e.target.name;
    const files = e.target.files[0];
    let page_data = this.state.page_data;
    page_data[index][propName] = files;
    this.setState({ page_data });
  };
  render() {
    this.validator.purgeFields();
    const { access, user_type, page_data, collapse } = this.state;
    console.log('page_data vide', page_data)
    return (
      <React.Fragment>

<div class="category_block">

<div class="titleline">
  <h4>Videos</h4>
</div>

        {page_data.map((item, index) => {
          return (

            <div className="eachblockgap">
             
            <Card className='panel-group custom-card' style={{ marginBottom: '1rem' }} key={index}>
            <CardHeader onClick={() => this.toggle(index)} data-event={index} className={item.set_id!=1?"branchcss":"maincss"}>
                  <div class="infoBoxColor">
                        <div class="org_item">
                        <div class="label_n">Category:</div>
                        <div class="item_n">{item.category_name}</div>
                        </div>
                        <div class="org_item">
                        <div class="label_n">Inst/Org Name:</div>
                        <div class="item_n item_n_name">{item.organisation_name}</div>
                        </div>
                        <div class="org_item">
                        <div class="label_n">Sub Category</div>
                        <div class="item_n">{item.sub_category_name ? item.sub_category_name : ''}</div>
                        </div>
                        <div class="org_item">
                        <div class="label_n">Type:</div>
                        <div className={item.set_id!=1?"item_n branchtext":"item_n"}>{item.set_id!=1?"Branch":"HQ"}</div>
                        </div>
                    </div>
                        {collapse !== index ? (
                    <div class="centeredexpcolbtn"><span className=''>
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        </span></div>
                        ) : (
                            <div class="centeredexpcolbtn"><span className=''>
                            <i class="fa fa-minus" aria-hidden="true"></i>
                            </span></div>
                        )}
                    <br/>

              </CardHeader>
              <Collapse isOpen={collapse === index}>
                <CardBody className='panel-body'>
                <h3 className="page-header">{item.organisation_name} <span style={{fontSize:"10px"}}><b>{item.set_id==3?"Branch":""}</b></span></h3>
                <p className='mar-btm'>{item.address}</p>
              
                  {item.is_active == 0 ?
                    (
                      <div className='row mar-btm'>
                        <div class="form-group col-md-12">
                          <h3 className='text-center'>Upgrade/Renewal to update the Data</h3>
                        </div>
                      </div>
                    ) :
                    (
                      <form onSubmit={(e) => this.submitForm(e, index)}>
                        <div class="box-shadow-custom">
                          <div class="row">
                            <div>
                              {item.exist_video != '' && (
                                <div className="row">
                                  <div class="form-group col-md-4">
                                    <label> Current Video <span className="astrick">*</span></label>
                                  </div>
                                  <div class="form-group col-md-6">
                                    <div className="row">
                                      { /* <Player
                                        src={item.exist_video}
                                      /> */} <br />
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div class="form-group col-md-4">
                                <label> Video <span className="astrick">*</span></label>
                              </div>
                              <div class="form-group col-md-6">
                                <input
                                  type="file"
                                  name="video_new"
                                  size="10024"
                                  onChange={(e) => this.handleFile(e, index)}
                                  className="form-control mar-btm"
                                  accept="video/mp4"
                                />
                               
                              </div>
                              <div class="col-md-12">
                              <span className="astrick"><li>inappropriate videos will be deleted</li></span>
                                <span className="astrick"><li>Uploading video should be within 10MB</li></span>
                                <span className="astrick"><li>Uploading video should be .mp4 format only and not more than 2 minutes.</li></span>
                                <span className="astrick"><li>Video will be displayed on the website after admin's approval.</li></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm">
                          <button type='submit' id="btnSubmit"
                            className="btn btn-primary btn-sm" disabled={this.state.btnDisabled}>
                            Submit Video Info
                          </button>
                        </div>
                        
                      </form>
                    )}
                </CardBody>
              </Collapse>
            </Card>

            </div>
          )
        })}
</div>
      <NotificationContainer/>  
      </React.Fragment >
    );
  }
  submitForm = (e, index) => {
    e.preventDefault();
    this.setState({
      btnDisabled: true
    });
    // console.log(this.state.user_data);
    // return false;
    const { user_type, login_id } = this.state.user_data;
    let page_data = this.state.page_data[index];
    
    if(!page_data.video_new){
      NotificationManager.error("no video is selected. Please choose any");
    }else{
    let request = {
      user_type: user_type,
      login_id: login_id,
      uid: page_data.uid,
      video_new: page_data.video_new ? page_data.video_new : [],
    };

    updateVideo(request).then(res => {
    
      if (res.status === 1) {
        NotificationManager.success('Video Submitted for admin`s Approval!');
         
        localStorage.setItem('is_completed', 1);

        this.setState({
          btnDisabled: false
        });
        /*
        setTimeout(function () {
          window.location.reload();
        }, 1000);
        */

      } else {
        NotificationManager.error(res.message);
        
      }
    });
    }
  };
}

export default Videos;



// WEBPACK FOOTER //
// ./src/components/bewise/partners/other_info/VideosV3.jsx